<template>
  <div>
    <div class="home">
      <NavBar :index="4" />
    </div>
    <img src="@/assets/img/label-Ct.png" alt="" style="padding-top: 60px" />
    <div class="phoneBox font18">
      <div style="">
        <div
          id="call"
          style="text-align: left; display: inline-block; padding-top: 30px"
        >
          <p style="margin-bottom: 10px">
            <img
              src="@/assets/img/p-mark1.png"
              alt=""
              style="margin-right: 10px"
            /><span>联系人：</span>hr 17722696719/18038067025、0755-84711199
          </p>

          <p style="margin-bottom: 10px">
            <img
              src="@/assets/img/e-mark2.png"
              alt=""
              style="margin-right: 10px"
            /><span>简历投递邮箱：</span
            >HR@rihaocpa.com、syd@rihaocpa.com、zsm@rihaocpa.com、wkk@rihaocpa.com
          </p>
          <div style="display: flex">
            <div>
              <img
                src="@/assets/img/o-mark3.png"
                alt=""
                style="margin-right: 10px"
              /><span>公司地址：</span>
            </div>
            <div>
              <p>深圳：广东省深圳市南山区高新中一道9号软件大厦9楼909号</p>
              <p>北京：北京市西城区复兴门外大街A2号1幢5层518室</p>
              <p>广西：广西南宁市良庆区庆歌路富雅国际商务大厦B座3021号</p>
            </div>
          </div>
        </div>
      </div>

      <div class="qr-wrap">
        <img class="qr-item" src="@/assets/img/app/QR-img1.png" alt="" />
        <img class="qr-item" src="@/assets/img/app/QR-img2.png" alt="" />
        <div class="qr-item qr-item-extra">
          <img class="qr-extra" src="@/assets/img/pc/QR-img3.png" alt="" />
          <div class="qr-caption">微信扫码添加咨询人事</div>
        </div>
      </div>
    </div>
    <Footer showBackgroundColor></Footer>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import { isMobile } from "@/assets/js/index";

export default {
  name: "page4",
  components: {
    NavBar,
    Footer,
  },
  mounted() {
    if (isMobile()) {
      this.$router.replace({ name: "mobile" });
    }
  },
};
</script>
<style scoped>
.phoneBox {
  line-height: 30px;
}
#call span {
  color: rgb(10, 150, 221);
  font-weight: 900;
  margin-right: 10px;
}
#call img {
  width: 26px;
  height: 26px;
}
p {
  line-height: 40px;
  letter-spacing: 2px;
}
.qr-wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  margin: 50px auto 100px;
  text-align: center;
}
.qr-item {
  display: block;
  height: 196px;
  width: auto;
}
.qr-item-extra {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 15px;
  height: auto;
}
.qr-extra {
  display: block;
  width: 180px;
  height: auto;
}
.qr-caption {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #555;
  line-height: 1.4;
  margin-left: 5px;
  text-align: center;
  text-indent: 0;
  white-space: nowrap;
}
</style>
